import { catchAll } from '@sorare/routing';

import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  ANY_SPORT_CARDS_SLUG,
  ANY_SPORT_MARKET,
  ANY_SPORT_MY_CLUB_SLUG_CARDS,
  ANY_SPORT_PLAYERS_SLUG,
  ANY_SPORT_SCOUTING_CENTER_STATS,
  ANY_SPORT_SCOUTING_CENTER_WATCHLISTS,
  ANY_SPORT_TEAMS_SLUG,
} from '@sorare/core/src/constants/__generated__/routes';

import { MarketSubscriptions } from '@sorare/marketplace/src/components/MarketSubscriptions';

const AUCTION_SUBSCRIPTION_ROUTES = [
  ANY_SPORT_CARDS_SLUG,
  ANY_SPORT_MY_CLUB_SLUG_CARDS,
  catchAll(ANY_SPORT_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(ANY_SPORT_TEAMS_SLUG),
  catchAll(ANY_SPORT_SCOUTING_CENTER_STATS),
  catchAll(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
];

const OFFERS_SUBSCRIPTION_ROUTES = [
  ANY_SPORT_CARDS_SLUG,
  catchAll(ANY_SPORT_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(ANY_SPORT_TEAMS_SLUG),
  catchAll(ANY_SPORT_SCOUTING_CENTER_STATS),
  catchAll(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
  ANY_SPORT_MY_CLUB_SLUG_CARDS,
];

const PRIMARY_OFFERS_SUBSCRIPTION_ROUTES = [
  ANY_SPORT_CARDS_SLUG,
  catchAll(ANY_SPORT_MARKET),
  catchAll(ANY_SPORT_PLAYERS_SLUG),
  catchAll(ANY_SPORT_SCOUTING_CENTER_STATS),
  catchAll(ANY_SPORT_SCOUTING_CENTER_WATCHLISTS),
];

export const NBAMarketSubscriptions = () => {
  return (
    <MarketSubscriptions
      sports={[Sport.NBA]}
      auctionsRoutes={AUCTION_SUBSCRIPTION_ROUTES}
      offersRoutes={OFFERS_SUBSCRIPTION_ROUTES}
      primaryOffersRoutes={PRIMARY_OFFERS_SUBSCRIPTION_ROUTES}
    />
  );
};
